import service, { HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);
interface MapBoxKeyPayload {
	mapBoxAPIKey: string;
}
interface GetMapBoxKeyApiResponse {
	data: MapBoxKeyPayload;
}

export const getCaptchaKey = (): Promise<HttpResponseSuccess<unknown>> =>
	apiService.get('/api/getKey/captcha');

export const getAdminTokenEncrypt = (): Promise<HttpResponseSuccess<unknown>> =>
	apiService.get('/api/getKey/adminTokenEncrypt');

export const getGoogleKey = (): Promise<HttpResponseSuccess<unknown>> =>
	apiService.get('/api/getKey/google');

export const getChurnZeroKey = (): Promise<HttpResponseSuccess<unknown>> =>
	apiService.get('/api/getKey/churnZero');

export const getNylasConfig = (): Promise<HttpResponseSuccess<unknown>> =>
	apiService.get('/api/getKey/nylasConfig');

export const getMapBoxKey = () =>
	apiService.get<GetMapBoxKeyApiResponse>('/api/getKey/mapBox');
